import { __extends } from "tslib";
import { BaseTelemetryPlugin, extend } from '@microsoft/1ds-core-js';
import { addOneDSFields } from './InternalUtils';
var PartAPlugin = /** @class */ (function (_super) {
    __extends(PartAPlugin, _super);
    function PartAPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.identifier = 'PartAPlugin';
        _this.priority = 3;
        _this._properties = {};
        return _this;
    }
    PartAPlugin.prototype.initialize = function (_coreConfig, _core, _extensions) {
        _super.prototype.initialize.call(this, _coreConfig, _core, _extensions);
    };
    /**
     * Process the event and add part A fields to it.
     * @param {object} telemetryEvent - The event that needs to be stored.
     */
    PartAPlugin.prototype.processTelemetry = function (telemetryEvent, itemCtx) {
        telemetryEvent.data = extend(this._properties, telemetryEvent.data);
        var itemContext = this._getTelCtx(itemCtx);
        this.processNext(telemetryEvent, itemContext);
    };
    /**
     * Add properties to send on every event
     * @param properties Properties to send on every event
     */
    PartAPlugin.prototype.addDataFields = function (dataFields) {
        addOneDSFields(this._properties, dataFields, {
            prependDataToken: false,
            customerContentEnabled: false
        });
    };
    return PartAPlugin;
}(BaseTelemetryPlugin));
export { PartAPlugin };
//# sourceMappingURL=PartAPlugin.js.map